<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg4 md4 sm12>
            <v-text-field
              :disabled="!roleEditable && customerId > 0"
              label="Mã khách hàng"
              v-model="currentCustomer.Username"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-text-field
              :disabled="!roleEditable && customerId > 0"
              label="Họ Tên"
              v-model="currentCustomer.FullName"
              
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
         <v-flex lg4 md4 sm12>
              <v-text-field
                :disabled="!roleEditable && customerId > 0"
                label="Điện thoại"
                v-model="currentCustomer.PhoneNumber"
                
                class="input-group--focused"
                :rules="requireRules"
              ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable && customerId > 0"
              label="Trạng thái"
              :items="customerStatus"
              v-model="currentCustomer.Status"
              item-text="name"
              item-value="value"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable && customerId > 0"
              label="Nhân viên sale"
              :items="sales"
              v-model="currentCustomer.SaleID"
              item-text="FullName"
              item-value="ID"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <!-- <v-flex lg6 md6 sm12>
            <h-currency-input :disabled="!roleEditable && customerId > 0" label="Phí cân lô" v-model="currentCustomer.ShipmentWeightPrice" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <h-currency-input :disabled="!roleEditable && customerId > 0" label="Phí khối lô" v-model="currentCustomer.ShipmentVolumePrice" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex> -->
          <v-flex lg12 md12 sm12>
            <v-text-field :disabled="!roleEditable && customerId > 0" label="Địa chỉ" v-model="currentCustomer.Address" class="input-group--focused"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="customerId > 0">
        <v-tabs v-model="tab" light right>
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            Phí cân
          </v-tab>

          <v-tab href="#tab-2">
            Phí khối
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-flex lg12 md12 sm12 pt-2 pl-3>
                <v-btn @click="showDialogWeight = true">Thêm mới</v-btn>
              </v-flex>
              <feeweight-list :currentUID="customerId" :showDialog="showDialogWeight"></feeweight-list>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-flex lg12 md12 sm12 pt-2 pl-3>
                <v-btn @click="showDialogVolume = true">Thêm mới</v-btn>
              </v-flex>
              <feevolume-list :currentUID="customerId" :showDialog="showDialogVolume"></feevolume-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import md5 from "md5";
import feeweight_list from "../FeeWeight/list";
import feevolume_list from "../FeeVolume/list";
export default {
  components: {
    "feeweight-list": feeweight_list,
    "feevolume-list": feevolume_list
  },
  data() {
    return {
      valid: true,
      tab: null,
      showDialogWeight: false,
      showDialogVolume: false,
      pwdWarning: "Mật khẩu không khớp.",
      password: "",
      rePassword: "",
      customerStatus: configs.CUSTOMER_STATUS_LIST,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  computed: {
    ...mapState({
      currentCustomer: state => state.customer.selected,
      loading: state => state.customer.loading,
      sales: state => state.staff.all.data,
    }),
    customerId() {
      return this.$route.params.Pid;
    },
    passwordConfirmationRule() {
      return this.password === this.rePassword || this.pwdWarning;
    },
    locationStore() {
        return configs.LOCATION_STORE;
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    }
  },
  watch: {
    roleEditable() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable && this.customerId > 0});
    },
    customerId() {
      if(!Number(this.customerId)) {
        this.$store.commit("customer/setCustomerDetail", {data: {}});
      }
    }
  },
  methods: {
    generateCode() {
      var acronym = this.currentCustomer.FullName ? this.currentCustomer.FullName.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'') : '';
      var phone = this.currentCustomer.PhoneNumber;
      phone = phone ? phone.substring(phone.length - 4, phone.length) : '';
      return (acronym + phone).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    refreshData() {
      if (this.customerId > 0) {
        this.$store.dispatch("customer/getCustomerDetail", this.customerId);
        this.$store.dispatch("staff/getList", {filter:[{column: "RoleID", value: configs.ROLE_TYPE.Sale, condition: "equal"}]});
      }
    },
    resetPassword() {
      this.showDialogWeight = false;
      this.showDialogVolume = false;
      this.currentCustomer.Password = md5('123@456');
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
        resetPwd: true
      });
    },
    saveData() {
      this.currentCustomer.Password = md5('123@456');
      this.$store.dispatch("customer/setCustomerDetail", {
        data: {
          ...this.currentCustomer,
          RoleID: configs.ROLE_TYPE.Customer
        },
        id: this.customerId
      }).then((ret) => 
              {
                  window.getApp.$emit("APP_NAVIGATE", "CustomerList");
              });      
    }
  },
  mounted() {
    this.refreshData();
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable && this.customerId > 0});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.resetPassword);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.resetPassword);
  }
};
</script>

<style>
</style>
